import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

/**
 * Provider cho React Query — lớp data của REST v4 (student), song song với Apollo cho GraphQL.
 *
 * QueryClient tạo trong useState (không phải module scope): trên server mỗi request phải có
 * cache riêng, để ở module scope là request này đọc được data của request khác.
 *
 * Mặc định:
 * - staleTime 60s: SSR trả data rồi thì client không refetch lại ngay.
 * - refetchOnWindowFocus false: trang ranking bị đổi tab liên tục, bật lên là spam request.
 * - retry 1: lỗi 4xx của v4 (409/422 khi đổi quà) retry cũng không khác gì.
 */
export default function ReactQueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
